import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Select from '@Components/DomElements/Select';
import SelectOption from '@Components/DomElements/SelectOption';
import ProcessApi from '@Data/processes/Api';
import { IProcess } from '@Data/processes/Interfaces';
import { filteredProcessesState } from '@Data/processes/Reducer';

const ProcessSelector = (props) => {
    const { selectedProcess, onSelectProcess } = props;

    const processes: Array<IProcess> = useSelector(filteredProcessesState);
    const selectRef = useRef();

    useEffect(() => {
        if (_isEmpty(processes)) {
            ProcessApi.getProcesses();
        }
    }, []);

    return (
        <Select
            id="process-selector"
            ref={selectRef}
            label="Tool Selector"
            value={
                selectedProcess ? selectedProcess.process_name : 'Select a tool'
            }
        >
            {processes.map((p) => (
                <SelectOption
                    id={`process-option-${p.process_id}`}
                    key={`opt-${p.process_id}`}
                    text={p.process_name}
                    parentRef={selectRef}
                    onClick={() => onSelectProcess(p)}
                />
            ))}
        </Select>
    );
};

ProcessSelector.propTypes = {
    selectedProcess: PropTypes.object,
    onSelectProcess: PropTypes.func,
    handleClear: PropTypes.func,
};

export default ProcessSelector;
